import React from 'react'

import PropTypes from 'prop-types'

import ErrorMessage from '../ErrorMessage/ErrorMessage'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    // Atualiza o state para que a próxima renderização mostre a UI alternativa.
    return { hasError: true, error }
  }

  render() {
    const { hasError } = this.state
    const { children } = this.props

    if (hasError) {
      return (
        <ErrorMessage
          src={`${process.env.REACT_APP_ASSETS_URL}/static/assets/images/what.svg`}
          title='Ops! Ocorreu um erro. Caso o erro persista, entre em contato com o suporte.'
        />
      )
    }

    return children
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
}

export default ErrorBoundary
